export type NotificationType = "success" | "error"; // | 'info' | 'warning'

export const ActionForNotification = {
  FETCH_STUDENT_DEAL: "FETCH_STUDENT_DEAL",
  FETCH_TUTOR_DETAIL: "FETCH_TUTOR_DETAIL",
  STORE_STUDENT_PERSONAL_DETAIL: "STORE_STUDENT_PERSONAL_DETAIL",
  STORE_STUDENT_DEAL_REQUIREMENT: "STORE_STUDENT_DEAL_REQUIREMENT",
  UPDATE_STUDENT_RATING: "UPDATE_STUDENT_RATING",
  STUDENT_PAYMENT_ORDER_EMAIL: "STUDENT_PAYMENT_ORDER",
  STUDENT_PAYMENT_RECEIPT: "STUDENT_PAYMENT_RECEIPT",
  STUDENT_PAYMENT_SEND_LINK: "STUDENT_PAYMENT_SEND_LINK",
  UPDATE_DEAL_ASSIGNED_CRE: "UPDATE_DEAL_ASSIGNED_CRE",
  UPDATE_DEAL_TIMING_SCHEDULE: "UPDATE_DEAL_TIMING_SCHEDULE",
  UPDATE_STUDENT_SUBSCRIPTION: "UPDATE_STUDENT_SUBSCRIPTION",
  UPDATE_DEAL_STATUS: "UPDATE_DEAL_STATUS",
  UPDATE_DEAL_PRIORITY_LEVEL: "UPDATE_DEAL_PRIORITY_LEVEL",
  ADD_DEAL_COMMENT: "ADD_DEAL_COMMENT",
};

export const popupTitleAndMessage: Record<
  keyof typeof ActionForNotification,
  Record<NotificationType, Record<"title" | "description", string>>
> = {
  FETCH_STUDENT_DEAL: {
    success: {
      title: "Success",
      description: "Fetched Student Deal",
    },
    error: {
      title: "Error",
      description: "Faced technical error while fetching student deal detail",
    }
  },
  FETCH_TUTOR_DETAIL: {
        success: {
      title: "Success",
      description: "Fetched Tutor Detail",
    },
    error: {
      title: "Error",
      description: "Faced technical error while fetching tutor detail",
    }
  },
  STORE_STUDENT_PERSONAL_DETAIL: {
    success: {
      title: "Success",
      description: "Student Personal detail has been successfully saved",
    },
    error: {
      title: "Error",
      description: "There was some issue in saving Student Personal detail",
    },
  },
  STORE_STUDENT_DEAL_REQUIREMENT: {
    success: {
      title: "Success",
      description: "Student Deal Requirement has been successfully saved",
    },
    error: {
      title: "Error",
      description: "There was some issue in saving Student Deal Requirement",
    },
  },
  UPDATE_STUDENT_RATING: {
    success: {
      title: "Success",
      description: "Student Rating has been successfully updated",
    },
    error: {
      title: "Error",
      description: "Faced an issue while updating rating",
    },
  },
  UPDATE_DEAL_ASSIGNED_CRE: {
    success: {
      title: "Updated CRE",
      description: "CRE has been successfully updated",
    },
    error: {
      title: "Could not update CRE",
      description: "Faced an issue while updating CRE",
    },
  },
  ADD_DEAL_COMMENT: {
    success: {
      title: "Comment",
      description: "successfully stored Comment",
    },
    error: {
      title: "Comment",
      description: "Faced an issue while storing Comment",
    },
  },
  UPDATE_DEAL_TIMING_SCHEDULE: {
    success: {
      title: "Success",
      description: "Successfully updated Timing and Schedule",
    },
    error: {
      title: "Error",
      description: "Faced an issue while Timing and Schedule",
    },
  },
  UPDATE_STUDENT_SUBSCRIPTION: {
    success: {
      title: "Success",
      description: "Successfully updated Student Subscription",
    },
    error: {
      title: "Error",
      description: "Faced an issue while updating Student Subscription",
    },
  },
  UPDATE_DEAL_STATUS: {
    success: {
      title: "Success",
      description: "Successfully updated Deal Statud",
    },
    error: {
      title: "Error",
      description: "Faced an issue while updating Deal Status",
    },
  },
  UPDATE_DEAL_PRIORITY_LEVEL: {
    success: {
      title: "Success",
      description: "Successfully updated Deal Priority Level",
    },
    error: {
      title: "Error",
      description: "Faced an issue while updating Deal Priority Level",
    },
  },
  STUDENT_PAYMENT_ORDER_EMAIL: {
    success: {
      title: "Order Email",
      description: "Order email has been sent successfully to customer",
    },
    error: {
      title: "Order Email",
      description: "Faced an issue while sending Order email",
    },
  },
  STUDENT_PAYMENT_RECEIPT: {
    success: {
      title: "Send Receipt",
      description: "Receipt has been sent successfully to customer",
    },
    error: {
      title: "Error",
      description: "Faced an issue while sending Receipt",
    },
  },
  STUDENT_PAYMENT_SEND_LINK: {
    success: {
      title: "Success",
      description: "Payment link has been sent successfully to customer",
    },
    error: {
      title: "Error",
      description: "Faced an issue while sending Payment link",
    },
  },
};
